/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Query-parameter DTOs in this API are intentionally kept string-typed (matching how Express/API Gateway actually deliver query params) rather than coerced to number/boolean before validation. Handlers that need a non-string value (e.g. `fuzziness`) parse it themselves after typia validation has confirmed the raw shape. This keeps `registerRoutes` generic and avoids a second, easy-to-drift coercion table living next to the routes.
 */
export interface UserSearchQueryDto { 
    search?: string;
    view?: UserSearchQueryDto.ViewEnum;
    fuzziness?: string;
}
export namespace UserSearchQueryDto {
    export const ViewEnum = {
        active: 'active',
        mandatory_flow: 'mandatory-flow',
        to_sync: 'to-sync'
    } as const;
    export type ViewEnum = typeof ViewEnum[keyof typeof ViewEnum];
}


